import React, { useRef } from "react";
import MenuLanguagesComponent from "./MenuLanguagesComponent";
import HandleClickOutside from "../../../../../Components/DOM/Click/HandleClickOutside";
import { useTranslation } from "react-i18next";
import { SHOW_LENGUAJE } from "../../../../../Utils/Constants";
import "./LanguagesComponent.css";

export const LanguagesComponent = ({ show, handelShow, handleClose, renderMobileVersion }) => {
  const { t } = useTranslation();
  const languagesRef = useRef(null);

  return (
    <div className={"languages"} ref={languagesRef}>
      <HandleClickOutside elementref={languagesRef} callback={handleClose} />
      <div className="tooltip-container">
        <div onClick={() => handelShow(SHOW_LENGUAJE)} className={"LanguageMenuIconContainer"}>
          <ion-icon name="globe-outline" id={"LanguageMenuIcon"} aria-label={t("catalogue.idioms")} />
        </div>
        <span className="tooltip-text">{t("catalogue.idioms")}</span>
      </div>
      <MenuLanguagesComponent
        renderMobileVersion={renderMobileVersion}
        handleShowLanguagesMenu={() => handelShow(SHOW_LENGUAJE)}
        showLanguagesMenu={show}
      />
    </div>
  );
};
